// extracted by mini-css-extract-plugin
module.exports = {"block":"e_kv","lead":"e_lv","faces":"e_mv","face":"e_nv","plus":"e_ov","copy":"e_pv","title":"e_qv","text":"e_rv","button":"e_sv","buttonIcon":"e_tv"};